// HomeContainer.js
import React from 'react';
import './Home.css'; // Assuming you have some CSS for this component

const HomeContainer = ({ children }) => {
  return <div className='Home-container'>{children}</div>;
};

export default HomeContainer;
